"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.yellow = exports.red = exports.green = exports.backgroundColor = exports.borderColor = exports.textColor = exports.titleColor = exports.secondary = exports.white = exports.primary = void 0;
var primary = '#6050DC';
exports.primary = primary;
var white = '#FFFFFF';
exports.white = white;
var secondary = '#0B0826';
exports.secondary = secondary;
var titleColor = '#212121';
exports.titleColor = titleColor;
var textColor = '#909090';
exports.textColor = textColor;
var borderColor = '#DEDEDE';
exports.borderColor = borderColor;
var backgroundColor = '#F5F6FA';
exports.backgroundColor = backgroundColor;
var green = '#3DCD58';
exports.green = green;
var red = '#E23943';
exports.red = red;
var yellow = '#F5A623';
exports.yellow = yellow;